var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-count"},[_c('div',{staticClass:"list"},_vm._l((_vm.countList),function(item,i){return _c('div',{class:['item', item.key]},[_c('div',{staticClass:"item-con"},[_c('span',{staticClass:"name"},[_vm._v(" "+_vm._s(item.name)+" ")]),_c('span',{staticClass:"num"},[_vm._v(" "+_vm._s(item.num ? item.num : '-')+" ")])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }